import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.792 2.204a.697.697 0 0 1 0 .985 10 10 0 0 0-1.041 1.227l1.122 1.122a.697.697 0 0 1-.985.985l-.882-.88a9 9 0 0 0-.497 1.176l4.535 4.534q.051.05.09.11.575-.195 1.121-.467L15.46 8.199a.697.697 0 1 1 .986-.985l3.045 3.044a9.7 9.7 0 0 0 1.288-1.084.698.698 0 1 1 .985.985c-2.437 2.438-5.822 3.583-8.882 2.987.697 2.951-.372 6.268-2.736 8.632a.7.7 0 0 1-1.157-.214.7.7 0 0 1 .171-.771 9 9 0 0 0 1.077-1.297L8.977 18.24a.696.696 0 1 1 .986-.986l.988.988a8.5 8.5 0 0 0 .43-1.142l-.044-.04-4.474-4.473a8 8 0 0 0-1.21.464l2.632 2.63a.697.697 0 0 1-.986.988l-2.892-2.894q-.662.463-1.235 1.034a.697.697 0 0 1-.985-.985c2.364-2.365 5.681-3.434 8.632-2.737-.595-3.06.549-6.445 2.987-8.882a.697.697 0 0 1 .986 0m.762 9.631-3.421-3.422a7.2 7.2 0 0 0 .252 3.171c1.002.32 2.084.4 3.171.252zm-4.201 1.043c.278.806.384 1.673.328 2.553l-3.145-3.145c.88-.056 1.747.05 2.553.328l.197.067z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }